<template>
  <div id="app" v-if="isMenu==1"  class="nk-wrap ">
    <MainHeader/>
    <div class="nk-content" style="margin-top: 4rem !important; padding: 0px !important;">
      <div class="container" style="max-width: 100%; background-color: #f2f3f3;">
        <div class="nk-content-inner">
          <MainMenu />
          <div class="nk-content-body">
            <router-view></router-view>
            <MainFooter />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="app" v-if="isMenu==0"  class="nk-wrap ">
    <router-view></router-view>
  </div>
</template>
<!-- <div id="app">

  <router-view></router-view>
</div> -->
<script>
import { mainBaseUrl } from '@/apis/appconst';
import MainHeader from "./comps/MainHeader.vue";
import MainFooter from "./comps/MainFooter.vue";
import MainMenu from "./comps/MainMenu.vue";

export default {
  name: 'App',
  components: {
    MainHeader,
    MainMenu,
    MainFooter
  },
  methods: {
    async getMyDtCall() {


    }
  },
  data() {
    return {
      base_url: "",
      isMenu:1
    };
  },
  created() {

    this.base_url = mainBaseUrl;
    const lastSegment = window.location.pathname.split('/');
   
        if(lastSegment[lastSegment.length-1].localeCompare("login")==0 ||
        lastSegment[lastSegment.length-2].localeCompare("booking")==0 ||
        lastSegment[lastSegment.length-2].localeCompare("appoint_report")==0){
            this.isMenu = 0;
        }
        else {
            this.isMenu = 1;
        }
  },
}
</script>

